import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';

const InformationIconFilled = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.00004 13.6666C3.31814 13.6666 0.333374 10.6818 0.333374 6.99992C0.333374 3.31802 3.31814 0.333252 7.00004 0.333252C10.6819 0.333252 13.6667 3.31802 13.6667 6.99992C13.6667 10.6818 10.6819 13.6666 7.00004 13.6666ZM7.00004 3.66659C7.36823 3.66659 7.66671 3.96506 7.66671 4.33325V7.66659C7.66671 8.03477 7.36823 8.33325 7.00004 8.33325C6.63185 8.33325 6.33337 8.03477 6.33337 7.66659V4.33325C6.33337 3.96506 6.63185 3.66659 7.00004 3.66659ZM6.33337 9.66659C6.33337 9.2984 6.63185 8.99992 7.00004 8.99992C7.36823 8.99992 7.66671 9.2984 7.66671 9.66659C7.66671 10.0348 7.36823 10.3333 7.00004 10.3333C6.63185 10.3333 6.33337 10.0348 6.33337 9.66659Z"
          fill="inherit"
        />
      </svg>
    );
  }
);
export default InformationIconFilled;
